import { FormikProps } from 'formik'
import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { AgGridTable } from '../../../utils/agGridTable/AgGridTable'
import { Button } from '../../../utils/Button'
import ArrayInput from '../../../utils/form/ArrayInput'
import { propsInterfaceFormGroupInput } from '../../../utils/form/FormGroupInput'
import { useBetween } from 'use-between'
import { BTCreateContract4 } from '../BTContract/BTCreateContract4'
import { BTCreateContract2 } from '../BTContract/BTCreateContract2'
import { BTCreateContract3 } from '../BTContract/BTCreateContract3'
import { warn, error } from '../../../utils/customToasd'
import { headerDetailFrequency, validateIngredientsFrequency, isValid, editStepGrid } from '../form/step.service'
import { ModalForm } from '../../../utils/modal/ModalForm'
import { quitarDuplicadoReceta } from '../../minutas/grillas/gridService'
import { setLStorage, getLStorage } from 'global.d'
import { ActionDataGrid4 } from '../form/ActionDataGrid4'
import { contStep4 } from '../form/StepContract4'
import { columnDefStep4 } from './loadService/StepLoadContract4.service'
import { useLocation, useNavigate } from 'react-router-dom'

const StepLoadContract4: FC<StepLoadContract4Props> = (props) => {
  const { setDataRow4, dataRow4 } = useBetween(BTCreateContract4)
  const { dataRow2 } = useBetween(BTCreateContract2)
  const { dataRow3, ingByCeco } = useBetween(BTCreateContract3)
  const columInput = 5
  const [open, setOpen] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [gridRef, setGridRef] = useState<any>()
  const [addRow, setAddRow] = useState(false)
  const [readOnlyFrequency, setReadOnlyFrequency] = useState(false)
  const [arrayInput, setArrayInput] = useState<propsInterfaceFormGroupInput[]>([])
  const [showModalMenu, setShowModalMenu] = useState(false)
  const [dataRowModal, setDataRowModal] = useState<any>()
  const [estrPadreSelected, setEstrPadre] = useState<any>()
  const [catDie, setCatDie] = useState<any>()
  const [btnStructure, setBtnStructure] = useState(props.title)
  const [columnDefs, setColumnDefs] = useState<any>([])
  const [disabledInput, setDisabledInput] = useState<boolean>(false)
  const location = useLocation()
  let _state: any = {}
  useEffect(() => {

    const state: any = location.state
    if (state?.params) {
      const contract = {
        ...state?.params,
        id: state?.contrato,
      }
      _state = contract
      if (contract?.plantilla > 0 || contract?.minuta > 0) {
        setDisabledInput(true)
      }
    }
  }, [])

  const callbackEdit = useCallback(
    async (data: any, formikProps, params) => {
      setBtnStructure('Editar frecuencia ingredientes')
      const edit = await getLStorage("edit")
      if (!edit) {
        setLStorage("idEdit", data.id)
        setLStorage("edit", !edit);
        setIsEdit(!edit)
        if (data.frequency > 0) {
          let dr4 = gridRef?.current?.props?.rowData;
          dr4 = dr4.filter((item: any, key: number) => item.id != data.id)
          dr4.forEach((item: any, key: number) => item.idDelete = key)
          gridRef?.current?.api?.setRowData(dr4)
          setDataRow4(dr4);
          formStep4(true, data, props.formikProps, undefined, true, true)
        }
      } else {
        warn("Debe finalizar la edición antes de editar otra fila")
      }
    },
    [
      props.formikProps?.values,
      isEdit,
      arrayInput,
      props.reload4
    ]
  )

  useEffect(() => {
    if (props.reload4) {
      const dataClumnDef = columnDefStep4(editStepGrid, callbackEdit, props, dataRow4, setDataRow4)
      setColumnDefs(dataClumnDef)
      formStep4(false, undefined, props.formikProps, dataClumnDef, undefined, true)
    }
  }, [
    props.reload4, isEdit, estrPadreSelected, catDie, dataRow4
  ])

  const hasComodin = (has: any) => {
    let comodin: any = []
    if (!has['29']) comodin.push({ text: '29', value: '29' })
    if (!has['30']) comodin.push({ text: '30', value: '30' })
    if (!has['31']) comodin.push({ text: '31', value: '31' })

    return comodin
  }

  const formStep4 = (edit: boolean, data?: any, formikProps?: FormikProps<any>, dataClumnDef?: any, seeComodin?: boolean, editInput?: boolean) => {

    try {
      if (!props.reload4) {
        return;
      }
      let tec: any = []
      let fatherStructure3 = data?.fatherStructure3;
      if (formikProps?.values?.fatherStructure3 && Array.isArray(formikProps.values.fatherStructure3) && formikProps.values.fatherStructure3.length > 0) {
        fatherStructure3 = formikProps.values.fatherStructure3[0].structure || formikProps.values.fatherStructure3[0].text;
      }
      let disable = readOnlyFrequency
      let hideComodin: boolean = true
      let hideWeek: boolean = false
      if (formikProps?.values?.templateType && Array.isArray(formikProps.values.templateType) && formikProps.values.templateType.length > 0) {
        const templateType: any = formikProps?.values.templateType[0].value
        if (templateType != 1) {
          hideWeek = true
        }

        if (templateType == 3) {
          const dc = columnDefs.length ? columnDefs : dataClumnDef
          hideComodin = false
          if (dc != undefined) {
            const colDef: any[] = dc;
            colDef[5].hide = true
            colDef[6].hide = false
            setColumnDefs(colDef)
            gridRef?.current?.api?.setColumnDefs(colDef)
          }
        }
      }

      const mapEstructuras = dataRow2.map((e: any) => {
        return {
          ...e,
          text: e.structure,
          value: e.idStructure,
        }
      })
      let mapIng: any = ingByCeco
      if (estrPadreSelected && estrPadreSelected?.plateTypes) {
        if (ingByCeco && ingByCeco.length) {
          if (catDie) {
            mapIng = quitarDuplicadoReceta(
              ingByCeco.filter(
                (e: any) => estrPadreSelected.plateTypes.includes(e.rec_tippla) &&
                  catDie.value == e.rec_catdie),
              'Idtipoingprincipal'
            )
          } else {
            mapIng = quitarDuplicadoReceta(
              ingByCeco.filter((e: any) => estrPadreSelected.plateTypes.includes(e.rec_tippla) &&
                estrPadreSelected.idDietaryCategory == e.rec_catdie),
              'Idtipoingprincipal'
            )
          }
        }
      } else {
        if (ingByCeco && ingByCeco.length) {
          mapIng = quitarDuplicadoReceta(
            ingByCeco.filter(
              (e: any) => dataRow2.findIndex((r: any) => r.plateTypes.includes(e.rec_tippla)) != -1
            ),
            'Idtipoingprincipal'
          )
        }
      }
      const propCat = props.data.categoriaDieteticaRec
      const weeks = formikProps?.values.weeks
      let optionsWeek: any = []
      for (let i = 1; i <= weeks; i++) {
        optionsWeek.push({ text: i.toString(), value: i.toString() })
      }
      let comodines = [
        { text: 'Normal', value: '0' },
      ]
      const {
        total,
        continueStep,
        structure,
        totalEstructuraPadre,
        diasBloqueados,
        totalEstructuraComodin
      } = validateIngredientsFrequency(
        dataRow3,
        gridRef.current.props.rowData,
        props.formikProps?.values,
        dataRow2,
        props.data.ingAdyacentes,
      )
      if (formikProps?.values.templateType[0].value == 3) {
        tec = totalEstructuraPadre[fatherStructure3];
        if (totalEstructuraPadre) {
          if (fatherStructure3 > 0) {
            if ((totalEstructuraPadre[fatherStructure3] + diasBloqueados) >= 28) {
              comodines = hasComodin(totalEstructuraComodin[fatherStructure3])
              if (formikProps?.values.comodin[0]?.text === "Normal") {
                clearInput('comodin', formikProps?.values)
                if (comodines.length) formikProps?.setFieldValue('comodin', [comodines[0]])
              }
              mapIng.push({ text: 'NO APLICA', value: '-1' })
              disable = (true)
              if (comodines[0].value === "0") {
                disable = false
              }
            } else {
              disable = false
              formikProps?.setFieldValue('comodin', [{ text: 'Normal', value: '0' }])
            }
          }
        }
        if (!fatherStructure3)
          if (seeComodin && fatherStructure3) {
            comodines = hasComodin(totalEstructuraComodin[fatherStructure3])
            clearInput('comodin', formikProps?.values)
            if (comodines.length) formikProps?.setFieldValue('comodin', [comodines[0]])
          }
      }
      let totalBloqueados = diasBloqueados[fatherStructure3]

      if (isNaN(totalBloqueados)) {
        totalBloqueados = 0
      }
      try {
        if (!isNaN(totalBloqueados) && diasBloqueados[fatherStructure3] !== undefined) {
          totalBloqueados = diasBloqueados[fatherStructure3]
        }
      } catch (error) {

      }
      let totalComodines = 0;
      totalEstructuraComodin[fatherStructure3]?.map((item: any) => {
        return totalComodines++
      })
      if (fatherStructure3 && totalEstructuraPadre[fatherStructure3] >= (28 - totalBloqueados) + totalComodines) {
        comodines = hasComodin(totalEstructuraComodin[fatherStructure3])
        if (formikProps?.values.comodin[0]?.text === "Normal") {
          clearInput('comodin', formikProps?.values)
          if (comodines.length) formikProps?.setFieldValue('comodin', [comodines[0]])
        }
      } else {
        comodines = [
          { text: 'Normal', value: '0' },
        ]
      }
      const itemsComodin = ['29', '30', '31'];
      let pushItem = false;
      comodines.map((item: any) => {
        if (itemsComodin.includes(item.text)) {
          pushItem = true;
        }
      })
      if (pushItem) {
        const result = mapIng.filter((item: any) => item.value === "-1");
        if (result.length === 0) {
          mapIng.push({ text: 'NO APLICA', value: '-1' })
        }
      }
      setArrayInput([
        {
          columInput: columInput,
          campo: 'fatherStructure3',
          label: 'Estructura',
          type: 'autocomplete',
          disabled: disabledInput,
          advanceOptions: {
            id: 'fatherStructure3',
            multiple: false,
            placeholder: 'Ingrese Estructura',
            options: mapEstructuras,
          },
          onChange: (event: any, setFieldValue: any, values: any) => {
            const est = values.fatherStructure3[0]
            if (est === undefined) {
              return
            }
            const { structure } = est
            if (est?.value != null && est?.value != undefined && est?.value !== '') {
              try {
                setEstrPadre(est)
                setCatDie({ text: est.dietaryCategoryAll, value: est.idDietaryCategory })
                setFieldValue('dietaryCategory3', [{ text: est.dietaryCategoryAll, value: est.idDietaryCategory }])
                setTimeout(() => {
                  const {
                    totalEstructuraPadre,
                    diasBloqueados,
                    totalEstructuraComodin
                  } = validateIngredientsFrequency(
                    dataRow3,
                    gridRef.current.props.rowData,
                    props.formikProps?.values,
                    dataRow2,
                    props.data.ingAdyacentes,
                  )
                  if (isNaN(diasBloqueados[structure])) {
                    diasBloqueados[structure] = 0
                  }
                  if (!isNaN(totalBloqueados) && diasBloqueados[structure] !== undefined) {
                    totalBloqueados = diasBloqueados[structure]
                  }
                  if (values.templateType[0].value == 3) {
                    let totalComodines = 0;
                    totalEstructuraComodin[structure]?.map((item: any) => {
                      return totalComodines++
                    })
                    if (structure && totalEstructuraPadre[structure] >= (28 - totalBloqueados) + totalComodines) {
                      comodines = hasComodin(totalEstructuraComodin[structure])
                      if (comodines.length) formikProps?.setFieldValue('comodin', [comodines[0]])
                    } else {
                      comodines = [
                        { text: 'Normal', value: '0' },
                      ]
                    }
                    formikProps?.setFieldValue('comodin', comodines);
                  }
                }, 600);
              } catch (e: any) {
                error(e)
              }
            } else {
              setEstrPadre(null)
              setFieldValue('dietaryCategory3', [])
            }
          },
          className: 'form-control form-control-lg step-2  input-contract',
        },
        {
          columInput: 2,
          campo: 'dietaryCategory3',
          label: 'Categoría dietética',
          type: 'tree-select',
          style: { width: '100%' },
          treeData: propCat,
          onChangeTree: async (
            setFieldValue: any,
            values: any,
            arrayInput: any,
            currentNode: any,
            selectedNodes: any
          ) => {
            if (values.dietaryCategory3.length && values.dietaryCategory3[0].value !== '') setCatDie(values.dietaryCategory3[0])
            else setCatDie(null)
          },
          className: 'bootstrap-demo w-100',
        },
        {
          columInput: columInput,
          campo: 'mainIngredients2',
          label: 'Ingredientes Principales',
          type: 'autocomplete',
          disabled: disabledInput, //_state.plantilla > 0 ? false : true,
          advanceOptions: {
            id: 'mainIngredients2',
            placeholder: 'Ingrese Ingredientes',
            multiple: false,
            options: mapIng,
          },
          className: 'form-control form-control-lg input-contract',
        },
        {
          columInput: columInput,
          campo: 'frequency',
          type: 'number',
          label: 'Frecuencia',
          disabled: disabledInput, //_state.plantilla > 0 ? false : true,
          placeholder: 'Ingrese frecuencia',
          readonly: disable,
          onBlur: (e, setFieldValue, values, arrayInput) => {
            if (values.fatherStructure3) {
              validateFrequency(values, setFieldValue)
            }
          },
        },
        {
          columInput: columInput,
          campo: 'cycles4',
          label: 'Semanas',
          type: 'autocomplete',
          hideInput: hideWeek,
          disabled: disabledInput, //_state.plantilla > 0 ? false : true,
          advanceOptions: {
            id: 'cycles4',
            placeholder: 'Semanas',
            multiple: true,
            options: optionsWeek,
          },
          className: 'form-control form-control-lg input-contract',
        },
        {
          columInput: columInput,
          campo: 'comodin',
          label: 'Comodín',
          type: 'autocomplete',
          hideInput: hideComodin,
          disabled: disabledInput, //_state.plantilla > 0 ? false : true,
          advanceOptions: {
            id: 'comodin',
            placeholder: 'Comodín',
            multiple: false,
            options: comodines,
          },
          className: 'form-control form-control-lg input-contract',
          onChange: (event: any, setFieldValue: any, values: any) => {
            const com = values.comodin[0]
            if (com?.value != null && com?.value != undefined && com?.value !== '') {
              if (com.value != '0') {
                setFieldValue('frequency', 1)
                setReadOnlyFrequency(true)
              } else {
                setReadOnlyFrequency(false)
              }
            }
          },
        },
      ])
      if (edit) {
        const cycles4 = data?.idCycles4.map((e: any) => {
          return { text: e.toString(), value: e.toString() }
        })
        formikProps?.setFieldValue('cycles4', cycles4)
        formikProps?.setFieldValue('frequency', data.frequency)
        formikProps?.setFieldValue('fatherStructure3', [{ text: data.fatherStructure3, value: data.idFatherStructure3 }])
        formikProps?.setFieldValue('mainIngredients2', [{ text: data.mainIngredients2, value: data.idMainIngredients2 }])
        formikProps?.setFieldValue('dietaryCategory3', [{ text: data.dietaryCategory3, value: data.idDietaryCategory3 }])
        if (formikProps?.values.templateType[0].value == 3)
          formikProps?.setFieldValue('comodin', [{ text: data.comodin, value: data.idComodin }])
      } else {
        formikProps?.setFieldValue('cycles4', optionsWeek)
      }

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    setLStorage("edit", false)
  }, [])

  useEffect(() => {
    if (props.reload4) {
      setLStorage('dataRow3', JSON.stringify(dataRow3))
      setLStorage('dataRow2', JSON.stringify(dataRow2))
      gridRef?.current?.api?.setRowData(dataRow4)
    }
  }, [dataRow3, dataRow4, gridRef, dataRow2, props.reload4])

  const validateFrequency = useCallback(
    async (values: any, setFieldValue: any) => {
      let dr3: any = dataRow3
      if (dr3.length === 0) {
        dr3 = await getLStorage('dataRow3')
        if (dr3 !== '') {
          dr3 = JSON.parse(dr3)
        } else {
          dr3 = []
        }
      }
      const {
        total,
        diasBloqueados,
        totalEstructuraComodin,
      } = validateIngredientsFrequency(
        dr3,
        gridRef.current.props.rowData,
        values,
        dataRow2,
        props.data.ingAdyacentes,
      )
      let totalBloqueados = diasBloqueados[values.fatherStructure3[0].text]

      if (isNaN(totalBloqueados)) {
        totalBloqueados = 0
      }
      let tfc = values.frequencyCycle;
      let totalComodines = 0;
      totalEstructuraComodin[values.fatherStructure3[0].text]?.map((item: any) => {
        return totalComodines++
      })
      if (values.templateType[0].value == 3) {
        tfc = 28;
        const arrayComodines = ['29', '30', '31'];
        if (arrayComodines.includes(values.comodin[0].text)) {
          setFieldValue('frequency', 1)
        }
        if (total > 28 && totalComodines === 0) {
          setFieldValue('frequency', 0)
          warn('La frecuencia no debe superar 28')
          return
        }
        if (values.comodin[0].text === "Normal")
          if ((tfc + totalComodines) - totalBloqueados < total) {
            setFieldValue('frequency', 0)
            warn('La frecuencia no debe superar ' + (tfc - totalBloqueados))
          }
      } else {
        if ((tfc + totalComodines) - totalBloqueados < total) {
          setFieldValue('frequency', 0)
          warn('La frecuencia no debe superar ' + (tfc - totalBloqueados))
        }
      }
    },
    [dataRow3, dataRow4, gridRef, dataRow2, props.reload4]
  )

  const clearInput = (id: string, obj: any) => {
    props.formikProps?.setFieldValue(id, [{ text: '', value: '' }])
    obj[id][0] = { text: '', value: '' }
  }

  const validateAdd = (values: any) => {
    if (!isValid(values, 'fatherStructure3', 'Debe selecionar estructura padre')) return false
    if (!isValid(values, 'dietaryCategory3', 'Debe selecionar categoría dietética')) return false
    if (!isValid(values, 'mainIngredients2', 'Debe selecionar ingrediente principal')) return false

    if (!values.frequency || values.frequency === '' || values.frequency == 0) {
      warn('Frecuencia debe ser mayor a cero')
      return false
    }

    if (values.templateType[0].value == '1') {
      if (!isValid(values, 'cycles4', 'Debe selecionar al menos una semana')) return false
    }

    if (values.templateType[0].value == '3') {
      if (!isValid(values, 'comodin', 'Debe seleccionar comodin')) return false
    }
    if (
      props.formikProps?.values.templateType[0].value == '3' &&
      values.comodin[0].value.toString() !== '0' &&
      dataRow4.length
    ) {
      if (values.comodin[0].value.toString() != props.formikProps?.values.comodin[0].text) {
        let rowIndex: any = dataRow4.findIndex(
          (e: any) =>
            e.idComodin == values.comodin[0].value.toString() &&
            e.idFatherStructure3 == values.fatherStructure3[0].value
        )
        if (rowIndex != -1) {
          warn(
            `Solo puedes agregar un comodín ${values.comodin[0].value.toString()} para la estructura ${values.fatherStructure3[0].text
            }`
          )
          return false
        }
      }
    }
    return true
  }

  useEffect(() => {
    if (!addRow) {
      return
    }
    if (open) {
      addStep4(false);
      setOpen(false)
    }

  }, [open, columnDefs])

  const addStep4 = async (edit: boolean) => {
    let obj = props.formikProps?.values
    let tipoPlan3: boolean = props.formikProps?.values.templateType[0].value == '3'
    const idRow = await getLStorage("idEdit");
    if (validateAdd(obj)) {
      let row = dataRow4.slice()
      obj.id = row.length
      let formContract4: contStep4 = {
        frequency: obj.frequency,
        fatherStructure3: obj.fatherStructure3[0].text,
        idFatherStructure3: obj.fatherStructure3[0].value,
        id: edit ? idRow : row.length,
        idDelete: 0,
        data: JSON.parse(JSON.stringify(obj)),
        mainIngredients2: obj.mainIngredients2[0].text,
        idMainIngredients2: obj.mainIngredients2[0].value,
        comodin: tipoPlan3 ? obj.comodin[0].text : 'Normal',
        idComodin: tipoPlan3 ? obj.comodin[0].value.toString() : '0',
        cycles4: obj.cycles4.length ? obj.cycles4.map((e: any) => e.text).join(',') : 'No aplica',
        idCycles4: obj.cycles4.map((e: any) => e.value),
        dietaryCategory3: obj.dietaryCategory3[0]?.tagLabel ? obj.dietaryCategory3[0]?.tagLabel : obj.dietaryCategory3[0].text,
        idDietaryCategory3: obj.dietaryCategory3[0].value,
      }
      clearInput('fatherStructure3', obj)
      clearInput('mainIngredients2', obj)
      clearInput('dietaryCategory3', obj)
      clearInput('comodin', obj)
      setEstrPadre(null)
      setCatDie(null)
      props.formikProps?.setFieldValue('frequency', 0)
      setReadOnlyFrequency(false)
      if (edit) {
        if (idRow !== undefined) {
          setIsEdit(false)
          setLStorage("edit", false);
          row.unshift(formContract4)
          row = row.filter((con: any) => con.frequency > 0)
          row.forEach((item: any, key: number) => item.idDelete = key)
          gridRef?.current?.api?.setRowData(row)
          
          setDataRow4(row)
        }
      } else {
        row.unshift(formContract4)
        row.forEach((item: any, key: number) => item.idDelete = key)
        gridRef?.current?.api?.setRowData(row)
        
        setDataRow4(row)
      }
    }
  }

  const editForm = useCallback(() => {
    addStep4(true)
    setBtnStructure(props.title)
    setLStorage("edit", false);
    setIsEdit(false)
  }, [props.formikProps, columnDefs])

  const detailFrequency = useCallback(() => {
    try {
      const { totalEstructuraPadre, diasBloqueados } = validateIngredientsFrequency(
        dataRow3,
        gridRef.current.props.rowData,
        props.formikProps?.values,
        dataRow2,
        props.data.ingAdyacentes,
      )
      const totalDetail: any = []
      const data = Object.keys(totalEstructuraPadre)
      data.map((item: any, key: number) => {
        const diasBloq = isNaN(diasBloqueados[item]) ? 0 : diasBloqueados[item]
        totalDetail.push({
          structure: item,
          total: props.formikProps?.values.frequencyCycle - diasBloq,
          admitted: totalEstructuraPadre[item],
        })
      })
      setDataRowModal(totalDetail)
      setShowModalMenu(true)
    } catch (err) {
      error('Error al mostrar el detalle de la frecuencia: ' + err)
    }
  }, [dataRow4, columnDefs, dataRow3, dataRow2, props.reload4])

  return (
    <div className='w-100'>
      <div className=''>
        <h2 className='text-dark'>
          {props.title}{' '}
          <i
            className='bi bi-info-circle btn-inf-ingredient-frequency'
            onClick={detailFrequency}
          ></i>
        </h2>
        <div className='text-gray-400 fw-bold fs-6'>{props.subTitle}</div>
      </div>
      <hr />
      <ArrayInput classContainer='container-input' arrayInput={arrayInput} />
      {props.bloqueado ?
        <></> :
        <Button
          className='btn-agregar'
          type='button'
          onClick={() => {
            if (btnStructure === 'Editar frecuencia ingredientes') {
              setLStorage("edit", true);
              editForm();
            } else {
              setLStorage("idEdit", 0)
              setLStorage("edit", false);
              setOpen(true)
              setAddRow(true)
            }
          }}
        >
          {btnStructure}
        </Button>
      }
      <AgGridTable rowHeight={90} setAGGridRef={setGridRef} columnDefs={columnDefs} dataRow={dataRow4}
        getRowStyle={(params: any) => {
          if (params.data.load) {
            return { background: 'lavender' };
          }
        }}
      />
      {showModalMenu && (
        <ModalForm
          show={showModalMenu}
          showTable={true}
          showSave={false}
          showClose={false}
          onSubmit={(_value: any, formikProps) => {
            setTimeout(() => {
              setShowModalMenu(false)
            }, 1000)
          }}
          close={() => {
            setShowModalMenu(false)
          }}
          title={'Detalle de Frecuencia'}
          colum={headerDetailFrequency()}
          rows={dataRowModal}
          modalFullscreen={false}
        />
      )}
    </div>
  )
}

interface StepLoadContract4Props {
  title?: string
  subTitle?: string
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void
  formikProps?: FormikProps<any>
  bloqueado?: boolean
  data?: any
  isReady?: boolean
  reload4?: boolean
}
export { StepLoadContract4 }
